// extracted by mini-css-extract-plugin
module.exports = {"bkg":"SplashScreen_bkg__r6Oce","box":"SplashScreen_box__9zFjs"};